export const GENDERS = [
  { code: 'F', title: 'Женщина' },
  { code: 'M', title: 'Мужчина' }
]

export const LANGUAGES = [
  { code: 'KK', title: 'Казахский' },
  { code: 'RU', title: 'Русский' }
]
